<template>
  <div>
    <AppHead v-if="$route.meta.head == null || $route.meta.head"/>
    <div class="MainContainer">
      <router-view/>
    </div>
    <AppFoot v-if="$route.meta.foot == null || $route.meta.foot"/>
  </div>
</template>

<script>
  import AppHead from './components/AppHead.vue'
  import AppFoot from "./components/AppFoot.vue";


  export default {
    name: "layout",
    created() {
    },
    components: {AppFoot, AppHead}
  }


</script>

<style scoped lang="scss">


</style>



// WEBPACK FOOTER //
// src/layout/index.vue